import React from 'react';
import Hint from '../../misc/Hint';
export default function ToolBoxIcon(_a) {
    var Icon = _a.Icon, _b = _a.hintPosition, hintPosition = _b === void 0 ? 'top' : _b, _c = _a.hintSize, hintSize = _c === void 0 ? 'medium' : _c, _d = _a.hint, hint = _d === void 0 ? '' : _d, onClick = _a.onClick;
    return (React.createElement(Hint, { hint: hint, size: hintSize, position: hintPosition },
        React.createElement(Icon, { onClick: onClick, width: 24, height: 24, style: { cursor: 'pointer' } })));
}
